module.exports = __webpack_public_path__ + "img/edge_divers_agenda.afac2d46.svg";